import { Application } from '@hotwired/stimulus';

import ApplicationController from './enterprise_admin/application_controller';
import ConfirmationModalController from './enterprise_admin/confirmation_modal_controller';
import FormController from './enterprise_admin/form_controller';
import DependentSelectController from './enterprise_admin/dependent_select_controller';
import HandlerController from './enterprise_admin/handler_controller';
import CoursesFilterController from './enterprise_admin/courses_filter_controller';
import CoursesFilterPillsController from './enterprise_admin/courses_filter_pills_controller';
import AnalyticsController from './shared/analytics_controller';
import FiltersCloserController from './enterprise_admin/filters_closer_controller';
import LandingPageLinkController from './enterprise_admin/landing_page_link_controller';
import TurboStreamsController from './shared/turbo_streams_controller';
import DraggableRowsTableController from './enterprise_admin/draggable_rows_table_controller';
import FeaturedProgramsTableController from './enterprise_admin/featured_programs_table_controller';
import AllProgramsTableController from './enterprise_admin/all_programs_table_controller';
import ProgramsFilterController from './enterprise_admin/programs_filter_controller';
import ProgramsFilterPillsController from './enterprise_admin/programs_filter_pills_controller';
import UserController from './enterprise_admin/user_menu_controller';
import ConsentModalController from './enterprise_admin/consent_modal_controller';
import SelectableColumnController from './enterprise_admin/selectable_column_table_controller';
import EnrollmentsTableController from './enterprise_admin/enrollments_table_controller';
import ButtonlessFormController from './shared/buttonless_form_controller';
import PasswordValidationsController from './shared/password_validations_controller';

const application = Application.start();
application.register('enterprise-admin--application', ApplicationController);
application.register('enterprise-admin--confirmation-modal', ConfirmationModalController);
application.register('enterprise-admin--form', FormController);
application.register('enterprise-admin--handler', HandlerController);
application.register('enterprise-admin--courses-filter', CoursesFilterController);
application.register('enterprise-admin--courses-filter-pills', CoursesFilterPillsController);
application.register('analytics', AnalyticsController);
application.register('enterprise-admin--filters-closer', FiltersCloserController);
application.register('dependent-select', DependentSelectController);
application.register('enterprise-admin--landing-page-link', LandingPageLinkController);
application.register('turbo-streams', TurboStreamsController);
application.register('enterprise-admin--draggable-rows-table', DraggableRowsTableController);
application.register('enterprise-admin--featured-programs-table', FeaturedProgramsTableController);
application.register('enterprise-admin--all-programs-table', AllProgramsTableController);
application.register('enterprise-admin--programs-filter', ProgramsFilterController);
application.register('enterprise-admin--programs-filter-pills', ProgramsFilterPillsController);
application.register('enterprise-admin--user-menu', UserController);
application.register('enterprise-admin--consent-modal', ConsentModalController);
application.register('enterprise-admin--selectable-column-table', SelectableColumnController);
application.register('enterprise-admin--enrollments-table', EnrollmentsTableController);
application.register('enterprise-admin--buttonless-form', ButtonlessFormController);
application.register('shared--password-validations', PasswordValidationsController);
